import Vue from "vue";
import Vuex from "vuex";
import generic from "./generic";
import form from "./form";
import bookingFunnel from "./bookingFunnel";
import coverageChecker from "./coverageChecker";
import washingsHistory from "./washingsHistory";
import garage from "./garage";
import login from "./login";
import vehicles from "./vehicles";
import vehicleConfigurator from "./vehicleConfigurator";
import personalArea from "./personalArea";
import priceCalculator from "./priceCalculator";
import requestWashout from "./requestWashout";
import createPersistedState from "vuex-persistedstate";
import SecureLS from "secure-ls";
export var ls = new SecureLS({
  encodingType: "aes",
  encryptionSecret:
    "6F918A169B5EA93AAB6CEDF4D2B6C2DC28B91D008094DA161A61541C514AA4DB",
  isCompression: false,
});
Vue.use(Vuex);

export default new Vuex.Store({
  plugins: [
    createPersistedState({
      storage: {
        getItem: (key) => {
          try {
            return key ? ls.get(key) || '' : '';
          } catch {
            return '';
          }
        } ,
        setItem: (key, value) => key ? ls.set(key, value) : false,
        removeItem: (key) => ls.remove(key),
        removeAll: () => ls.removeAll(),
      },
    }),
  ],
  modules: {
    generic,
    bookingFunnel,
    coverageChecker,
    washingsHistory,
    garage,
    login,
    vehicles,
    vehicleConfigurator,
    personalArea,
    priceCalculator,
    requestWashout,
    form
  },
});
